import { Link } from 'react-router-dom'
import s from './index.module.css'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { selectProfile } from '@store/profile.reducer'
import RoleList from './RoleList'
import { formateName } from '@helpers/formateName'
import { getAvatar } from '@helpers/getAvatar'
import { AuthService } from '@/services/AuthService'
import { useScreenWidth } from '@hooks/useScreenWidth'
import { Drawer, Dropdown } from 'antd'
import { NavigationApp } from '@common/Sidebar'
// import { CardHeader } from '@pages/Main/Hero/Card'
import classNames from 'classnames';
import { EditOutlined, ExportOutlined, CommentOutlined, CustomerServiceOutlined } from '@ant-design/icons'
import QModals from '@/components/pages/Main/Requests/Qmodals/index.jsx'
// import { getMyLevel } from '../../../helpers/getMyLevel';

const Header = () => {
  const isMobile = useScreenWidth(992)


  const profile = useSelector(selectProfile)
  const handleLogout = () => AuthService.logout()
  if (isMobile) return <Mobile {...{ profile, handleLogout }} />
  return <Desktop {...{ profile, handleLogout }} />
}

export default Header


const Mobile = ({ profile, handleLogout }) => {
  const [open, setOpen] = useState(false);
  const showDrawer = () => setOpen(true)
  const onClose = () => setOpen(false)

  // const level = getMyLevel(profile?.pulses)

  const items = [
    {
      key: '1',
      label: <div style={{ display: 'flex' }}>
        {formateName(profile.name, 'I F')}
        <button className={s.modalQuit} onClick={handleLogout}><ExportOutlined /></button>
      </div>,
    },
    { type: 'divider' },
    {
      key: '2',
      label: <Link to='/personal'>Редактировать</Link>,
      icon: <EditOutlined />,
    },
    {
      key: '3',
      label: 'Чат',
      disabled: true,
      icon: <CommentOutlined />,
    },
    {
      key: '4',
      label: 'Техподдержка',
      disabled: true,
      icon: <CustomerServiceOutlined />,
    },
  ]

  return <>
    <Drawer
      {...{
        title: <img src="/logo.svg" className={s.logoDraw} alt='logo' />,
        placement: "left",
        onClose: onClose,
        open: open,
        closable: false,
        width: 250,
        // footer: <>
        //   {profile?.role === 'children' && <div className={s.balance}>
        //     Баланс <span>{0} руб</span>
        //   </div>}
        //   <div style={{ marginLeft: -14, marginRight: -14 }}><CardHeader
        //     {...{
        //       name: `Уровень ${level.lvl}`,
        //       nameDescr: level.name,
        //       nameValue: `${level.percent}%`,
        //       ico: 'fire',
        //       value: level.percent,
        //       maxValue: 100,
        //     }}
        //   /></div>
        // </>,
        children: <div className={s.navList}><NavigationApp onClose={onClose} /></div>
      }}
    />

    <header className={`app-header ${s.wrapper}`}>
      <button className={`burger ${s.burger}`} onClick={showDrawer}></button>

      <Link to="/" className={s.logo}><img src="/logo.svg" alt="logo" /></Link>

      <div className={s.settingWrapper}>
        <Dropdown menu={{ items }} trigger={['click']}>
          <div className={classNames(s.photo, 'pointerCursor')}>
            <div className={s.avatar}>
              <img src={getAvatar(profile)} alt="Name" />
            </div>
          </div>
        </Dropdown>
      </div>

    </header >
  </>
}



const Desktop = ({ profile, handleLogout }) => {
  const [show, setShow] = useState(false)
  const [type, setType] = useState(false)
  const handleClick = () => {
    setShow(true)
    setType('ProblemSite')
  }
  
  
  return <><header className={`app-header ${s.wrapper}`}>
    <RoleList userRole={profile.role} roles={profile.roles} />

    <button className={s.button} title='Обратная связь' onClick={handleClick}>
      <svg xmlns="http://www.w3.org/2000/svg" width="19" height="20" fill="none">
        <path fill='currentColor' d="M18.7954 10.92a3.9892 3.9892 0 0 0-.3435-1.6027A3.9047 3.9047 0 0 0 17.4964 8a8.1596 8.1596 0 0 0-.7521-3.42c-.6332-1.3688-1.633-2.5255-2.8831-3.3355-1.25-.81-2.699-1.24-4.1784-1.24-1.4793 0-2.9283.43-4.1783 1.24S3.2546 3.2112 2.6214 4.58A8.2106 8.2106 0 0 0 1.8694 8l-.215.19c-.704.786-1.0947 1.8136-1.0947 2.88 0 1.0665.3907 2.0942 1.0949 2.88.3477.3852.769.6931 1.2377.9046a3.666 3.666 0 0 0 1.4872.3254h.42a.9555.9555 0 0 0 .375-.0742.9755.9755 0 0 0 .3184-.2158 1.0116 1.0116 0 0 0 .2833-.67V8c0-.2652-.103-.5195-.286-.707A.9653.9653 0 0 0 4.7993 7h-.4102a4.0393 4.0393 0 0 0-.4883.05 5.9725 5.9725 0 0 1 .4883-1.62c.4755-1.0252 1.2253-1.8914 2.1623-2.498.937-.6064 2.0228-.9283 3.1314-.9283 1.1085 0 2.1943.3219 3.1313.9284.937.6065 1.6868 1.4726 2.1623 2.498a5.974 5.974 0 0 1 .4884 1.62 4.041 4.041 0 0 0-.4884-.05h-.4102a.9652.9652 0 0 0-.6906.2928 1.0121 1.0121 0 0 0-.286.7071v5.83a1.0217 1.0217 0 0 0 .0725.3839 1 1 0 0 0 .2108.3261.9745.9745 0 0 0 .3184.2158.9558.9558 0 0 0 .375.0742h.4102a3.5116 3.5116 0 0 0 .5665-.06V17a1.012 1.012 0 0 1-.2861.7071.965.965 0 0 1-.6906.2929h-.9767a2.785 2.785 0 0 0 .0488-.5 2.5502 2.5502 0 0 0-.1904-.9684 2.5045 2.5045 0 0 0-.5419-.8173 2.4356 2.4356 0 0 0-.8088-.5385A2.3916 2.3916 0 0 0 11.1479 15H9.1945c-.6476 0-1.2686.2634-1.7265.7323-.458.4688-.7152 1.1047-.7152 1.7677 0 .6631.2572 1.299.7152 1.7678.4579.4688 1.079.7322 1.7265.7322h5.3718c.7771 0 1.5224-.316 2.0719-.8786.5495-.5627.8582-1.3257.8582-2.1214v-3a.7276.7276 0 0 0 0-.14 3.8652 3.8652 0 0 0 .963-1.3247 3.9492 3.9492 0 0 0 .336-1.6153Zm-16.2717.19c-.0053-.5587.1972-1.0986.5665-1.51a1.8621 1.8621 0 0 1 .7325-.49v4a1.9477 1.9477 0 0 1-.7325-.48c-.369-.4155-.5713-.9583-.5665-1.52ZM9.683 18h-.4884a.4825.4825 0 0 1-.3453-.1464.5063.5063 0 0 1-.143-.3536.5059.5059 0 0 1 .143-.3535A.4826.4826 0 0 1 9.1945 17h1.9534a.4826.4826 0 0 1 .3453.1465.5058.5058 0 0 1 .143.3535.5062.5062 0 0 1-.143.3536.4825.4825 0 0 1-.3453.1464h-1.465Zm5.8601-5.27V9.1c.3786.12.7097.361.9448.6876.2352.3266.3621.7217.3621 1.1274 0 .4058-.1269.8009-.3621 1.1275a1.8568 1.8568 0 0 1-.9448.6875Z" />
      </svg>
    </button>

    <button className={s.button} title='Уведомления'>
      < svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" fill="none" >
        <path fill='currentColor' d="M16.9582 0H3.2846c-.7771 0-1.5224.316-2.072.8787C.6633 1.4413.3546 2.2043.3546 3v10c0 .7956.3087 1.5587.8582 2.1213.5495.5626 1.2948.8787 2.0719.8787h13.6736c.7771 0 1.5224-.3161 2.0719-.8787.5495-.5626.8582-1.3257.8582-2.1213V3c0-.7957-.3087-1.5587-.8582-2.1213C18.4806.316 17.7353 0 16.9582 0Zm.9767 13a1.012 1.012 0 0 1-.2861.7071.9652.9652 0 0 1-.6906.2929H3.2846a.9654.9654 0 0 1-.6907-.2929A1.0122 1.0122 0 0 1 2.308 13V3c0-.2652.1029-.5196.286-.7071A.9653.9653 0 0 1 3.2846 2h13.6736a.965.965 0 0 1 .6906.2929A1.012 1.012 0 0 1 17.9349 3v10Zm-2.1682-7.62c.1597.2072.2328.4707.2036.733a1.0067 1.0067 0 0 1-.3599.667l-3.6626 3c-.5189.4235-1.1628.6541-1.8264.6541S8.8139 10.2035 8.295 9.78l-3.6626-3a1.01 1.01 0 0 1-.3038-.656 1.0164 1.0164 0 0 1 .2096-.6934.9723.9723 0 0 1 .6126-.3656.9585.9585 0 0 1 .6927.155l3.6723 3a.9624.9624 0 0 0 .6056.2154.9621.9621 0 0 0 .6055-.2154l3.6724-3a.9605.9605 0 0 1 .7159-.2085.9713.9713 0 0 1 .6515.3685Z" />
      </svg >
      {/* <span className="notice">1</span> */}
    </button >

    <button className={`${s.button} ${s.buttonQuit}`} title='Выйти' onClick={handleLogout}>
      < svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" fill="none" >
        <path fill='currentColor' fillRule="evenodd" d="m11.0365 13.0154 2.477-2.536H4.2656V8.521h9.2479l-2.477-2.536 1.358-1.3806 4.7817 4.8958-4.7817 4.8958-1.358-1.3806ZM15.7409.6875c1.0564 0 1.9127.8768 1.9127 1.9583v4.5727l-1.9127-1.9583V2.6458H2.3521v13.7084H15.741v-2.6144l1.9127-1.9583v4.5727c0 1.0815-.8563 1.9583-1.9127 1.9583H2.3521c-1.0615 0-1.9126-.8813-1.9126-1.9583V2.6458c0-1.0868.8511-1.9583 1.9126-1.9583H15.741Z" clipRule="evenodd" />
      </svg >
    </button >
  </header >
  <QModals type={type} active={show} setActive={setShow} />
  </>
}
